import { render, staticRenderFns } from "./QuestionsV2.vue?vue&type=template&id=7328097b&scoped=true"
import script from "./QuestionsV2.vue?vue&type=script&lang=js"
export * from "./QuestionsV2.vue?vue&type=script&lang=js"
import style0 from "./QuestionsV2.vue?vue&type=style&index=0&id=7328097b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328097b",
  null
  
)

export default component.exports